export default "__VITE_ASSET__CyABoDYO__"